export default "__VITE_ASSET__BlEND3r$__"